const idealCountries = [
  'NL'
];

export default idealCountries;


// WEBPACK FOOTER //
// ./src/constants/ideal-countries.js